import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { Constants } from './Constants';
import './index.css';
import { AuthConfig, AuthHelper, AuthType } from './libs/auth/AuthHelper';
import { store, persistor } from './redux/app/store';
import React from 'react';
import { setAuthConfig } from './redux/features/app/appSlice';

if (!localStorage.getItem('debug')) {
    localStorage.setItem('debug', `${Constants.debug.root}:*`);
}

let container: HTMLElement | null = null;
let root: ReactDOM.Root | undefined = undefined;
let msalInstance: PublicClientApplication;

document.addEventListener('DOMContentLoaded', () => {
    if (!container) {
        container = document.getElementById('root');
        if (!container) {
            throw new Error('Could not find root element');
        }
        root = ReactDOM.createRoot(container);

        renderApp();
    }
});

export function renderApp() {
    const authConfig: AuthConfig = {
        aadAuthority: process.env.REACT_APP_AAD_AUTHORITY ?? '',
        aadClientId: process.env.REACT_APP_AAD_CLIENT_ID ?? '',
        aadApiScope: process.env.REACT_APP_AAD_API_SCOPE ?? '',
        authType: AuthType.AzureAd,
    };

    store.dispatch(setAuthConfig(authConfig));

    if (AuthHelper.isAuthAAD()) {
        msalInstance = new PublicClientApplication(AuthHelper.getMsalConfig(authConfig));
        void msalInstance
            .initialize()
            .then(() => {
                void msalInstance
                    .handleRedirectPromise()
                    .then((response) => {
                        if (response) {
                            msalInstance.setActiveAccount(response.account);
                        }
                    })
                    .catch((error: unknown) => {
                        console.error('Error handling redirect promise:', error);
                    });

                root?.render(
                    <React.StrictMode>
                        <ReduxProvider store={store}>
                            <PersistGate loading={null} persistor={persistor}>
                                <MsalProvider instance={msalInstance}>
                                    <App />
                                </MsalProvider>
                            </PersistGate>
                        </ReduxProvider>
                    </React.StrictMode>,
                );
            })
            .catch((error: unknown) => {
                console.error('Error initializing MSAL:', error);
            });
    } else {
        root?.render(
            <React.StrictMode>
                <ReduxProvider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <App />
                    </PersistGate>
                </ReduxProvider>
            </React.StrictMode>,
        );
    }
}
